import { forwardRef } from 'react';
import Divider from '@segment/matcha/components/Divider';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Subheading.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseSubheading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return _jsxs(views.Wrapper, {
    children: [_jsx(views.Subheading, {
      variant: "pSmall",
      ref: ref,
      color: tokens.color,
      children: children
    }), _jsx(Divider, {})]
  });
});
var Subheading = withDesignTokens(BaseSubheading, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  }
});
export default Subheading;